<section class="cart-summary-shell">
  <header class="cart-summary-header">
    <h1>Shopping Cart</h1>
    <p>Review your items and proceed to quote request.</p>
  </header>

  <div class="cart-summary-layout">
    <div class="cart-left-column">
      <div class="cart-table-card">
        <div class="cart-table-header" aria-label="Shopping cart columns">
          <span class="header-product">Product</span>
          <span class="header-qty">Qty</span>
          <span class="header-unit">Sales Unit</span>
          <span class="header-unit-price">Unit Price</span>
          <span class="header-total-price">Total Price</span>
          <span class="header-remove" aria-hidden="true"></span>
        </div>

        @for (item of cartItems; track item.id) {
          <div class="cart-item-row">
            <div class="product-cell">
              <div class="product-thumb" (click)="goToDetail(item,$event)" [class.small]="item.compactThumb" aria-hidden="true">
              <cx-media [container]="item.product?.images?.PRIMARY" [format]="'cartIcon'"
                  [alt]="item?.product?.images?.altText">
                </cx-media>
                </div>
              <div class="product-details">
                <h2 (click)="goToDetail(item,$event)">{{ item.name }}</h2>
                <p class="product-code">Material #: {{ item.partNumber }}</p>

                <div class="comments-row">
                  <label class="comments-label" [for]="'comments-' + item.id">Comments (optional)</label>
                  <textarea
                    [id]="'comments-' + item.id"
                    rows="1"
                    placeholder="Enter comments"
                    [(ngModel)]="item.itemComments"
                    (input)="onCommentsInput(item, $event)"
                  ></textarea>
                </div>
              </div>
            </div>

            <div class="quantity-cell">
              <div class="quantity-editor" aria-label="Quantity selector">
                <button type="button" aria-label="Decrease quantity" (click)="decreaseQuantity(item.id)">−</button>
                <input
                  type="number"
                  min="1"
                  [value]="item.quantity"
                  aria-label="Product quantity"
                  (input)="onQtyChange(item.id, $event)"
                />
                <button type="button" aria-label="Increase quantity" (click)="increaseQuantity(item.id)">+</button>
              </div>
            </div>

            <div class="sales-unit-cell">
              <span class="sales-unit-value">{{ item.salesUnit }}</span>
            </div>

            <div class="unit-price-cell">
              <span class="unit-price-value">{{ item?.knbrTotalPrice?.listPrice === 0 ? 'Quoted' : item?.knbrTotalPrice?.formatedListPrice }}</span>
            </div>

            <div class="total-price-cell">
              <span class="total-price-value">{{ item?.totalPrice?.value === 0 ? 'Quoted' : item?.totalPrice?.formattedValue }}</span>
            </div>

            <div class="remove-cell">
              <button type="button" class="remove-item" aria-label="Remove item" (click)="removeCartItem(item.id)">×</button>
            </div>
          </div>
        }
      </div>

      <div class="disclaimer-section">
        <div class="disclaimer-icon">
          <i class="fas fa-info-circle"></i>
        </div>
        <div class="disclaimer-content">
          <h3>Disclaimer</h3>
          <p>This is a request for quote only and does not constitute an order or a commitment to sell.</p>
          <p>Pricing, availability and lead times are subject to change.</p>
          <p>A sales representative will contact you with the quote details.</p>
        </div>
      </div>
    </div>

    <aside class="checkout-panel">
      <label class="quote-summary-label">Quote Summary</label>
      <div class="total-estimation">
        <label>Total(Est.)</label>
        <label>{{ totalPrice?.value === 0 ? 'Quoted' : totalPrice?.formattedValue }}</label>
      </div>

      <label class="order-number-label" for="jobNumber">PO/Job Number</label>
      <input id="jobNumber" type="text" placeholder="Enter PO or Job Number" [(ngModel)]="poNumber" (input)="onPoNumberInput($event)" />
      @if (poNumberError) {
        <p class="po-number-error" role="alert">{{ poNumberError }}</p>
      }
      <button type="button" class="primary-button" [disabled]="checkoutDisabled" (click)="proceedToCheckout()">Request to Quote</button>
      <button (click)="navigate('/search/active-brands')" type="button" class="secondary-button">Continue Shopping</button>
    </aside>
  </div>
</section>
